import React, {useContext} from 'react'
import {SettingsContext} from '../context/settingsContext'

import {Radio, RadioButtonGroup, IconSettings} from '@salesforce/design-system-react';

function SalesforceConfigExtra() {
	const {associatedCaseRecordType, changeAssociatedCaseRecordType} = useContext(SettingsContext)

	const options = ['Nothing', 'A Contact', 'An Account']
	const labels = { label: 'When creating a Case also create:' }

	return (
		<IconSettings iconPath="/icons">
			<div className="panel-padding">
				<RadioButtonGroup
					labels={labels}
					onChange={(event) => changeAssociatedCaseRecordType(event.target.value)}
				>
					{options.map((option) => (
						<Radio
							key={option}
							id={option}
							labels={{ label: option }}
							value={option}
							checked={associatedCaseRecordType === option}
							variant="button-group"
						/>
					))}
				</RadioButtonGroup>
			</div>
		</IconSettings>
	)
}

SalesforceConfigExtra.displayName = 'RadioButtonGroupExample';

export default SalesforceConfigExtra